module.exports = __webpack_public_path__ + "img/sq6m_04.308dff4f.jpg";